<app-workflow-step-layout [infoWidth]="'32rem'" [readOnly]="readOnly">
  <ng-container info>
    <div>

      <h3>Verwendete Chargen</h3>

      <app-batches-selector
        [showExpirationDate]="false"
        [readOnly]="readOnly"
        [forms]="batchFormArray"
        (onChange)="validateStep()">
      </app-batches-selector>

      <h3>Verwendete statische Werte</h3>

      <div class="cutoff-value">
        <div>Cutoff:</div>
        <div>{{workflowStep.cutoffValue | number: '1.3-3'}} ng/µL</div>
        <div>Steigung (m):</div>
        <div>{{workflowStep.glomaxSlope | number: '1.3-3'}}</div>
        <div>Konstante (b):</div>
        <div>{{workflowStep.glomaxConstant | number: '1.3-3'}}</div>
        <div>µL eingesetzte DNA:</div>
        <div>{{workflowStep.dnaSetIn | number: '1.1-1'}}</div>
      </div>

      <h3>Verwendete Formeln</h3>

      <div>Konzentration [ng/µl] = (m * RFU + b) / µL eingesetzte DNA</div>

      <div *ngIf="!readOnly" class="file-upload-container">
        <h3>Datei hochladen</h3>
        <app-file-upload (onFileSelect)="onFilesAdded($event)" [clearFilesOnInput]="true"></app-file-upload>
      </div>

    </div>

    <app-position-detail
      *ngIf="selectedPosition"
      [showMeasurement]="true"
      [showChangeStateButton]="!readOnly"
      [position]="selectedPosition">
    </app-position-detail>

  </ng-container>

  <ng-container plate>
    <app-plate-view
      [plateMode]="PlateMode.MEASURED"
      [workflowInstance]="workflowInstance"
      [plates]="workflowStep?.plates"
      (onPositionSelected)="onCellClick($event)"
      (onClearPositionSelected)="onCellClick(null)">
    </app-plate-view>
  </ng-container>
</app-workflow-step-layout>
